import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";
import SectionHeading from "components/shared/SectionHeading";
import SubText from "components/shared/SubText";
import RadioSkeleton from "components/skeleton/RadioSkeleton";
import { RouteName } from "constant/routeNames";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import LikeService from "services/music/LikeService";
import RadioService from "services/radio/RadioService";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const RadioCard = lazy(() => import("pages/radioPage/shared/RadioCard"));

function WelcomePageRadioSection({ text, user }: any) {
  const [stations, setStations] = useState([]);
  const [isLoading, setIsLoading] = useState<any>(false);
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  useEffect(() => {
    setIsLoading(true);
    RadioService.getRandomRadioStations().then((res) => {
      // console.log(res.slides);
      setIsLoading(false);
      setStations(res.randomRadioStations);
    });
  }, []);

  //Like function
  const [favorite, setFavorite] = useState<any>();

  useEffect(() => {
    if (user && loggedInUser) {
      LikeService.getFavoriteById(loggedInUser?.id, user?.id)
        .then((res) => {
          const favoritesIds = res?.profile?.favorite_radio_stations?.map(
            (item: any) => item.id,
          );
          setFavorite(favoritesIds);
        })
        .catch(() => {});
    }
  }, [user]);
  return (
    <div className="mb-10">
      {/* top section */}
      {!isLoading && (
        <ErrorBoundary>
          <Suspense fallback={<RadioSkeleton />}>
            <div className="mt-5 mb-8 flex w-[95%] items-center justify-between">
              <div>
                <SectionHeading text={text} className="font-bold" />
              </div>
              <Link to={RouteName.SeeAllMightLikeRoute} className="group shrink-0">
                <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                  See all
                  <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                    →
                  </span>
                </p>
              </Link>
            </div>
            {/* coursel */}
            <div className="">
              <Swiper
                slidesPerView={6}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  370: {
                    slidesPerView: 2,
                  },
                  700: {
                    slidesPerView: 3,
                  },
                  1000: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 5,
                  },
                  1400: {
                    slidesPerView: 6,
                  },
                  1600: {
                    slidesPerView: 7,
                  },
                }}
                modules={[Pagination, Navigation]}
                navigation={true}
                className="mt-8 mb-10 mySwiper"
              >
                {stations?.map((station: any, i: number) => (
                  <SwiperSlide key={i}>
                    <RadioCard
                      station={station}
                      user={user}
                      favorite={favorite}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Suspense>
        </ErrorBoundary>
      )}
      {isLoading && <RadioSkeleton />}
    </div>
  );
}

export default WelcomePageRadioSection;